import React, { Component } from 'react';
import { Onboarding } from '$components/projects';
import { Translate } from '$common';
import { sendSlackMessage } from '../../api';
import { connect } from 'react-redux';
import {changeTitle, showNotification} from '$actions/root';

@connect(null, { showNotification, changeTitle })
export default class OnboardingRoute extends Component {

  componentWillMount() {
    this.props.changeTitle(Translate.get('what_do_you_need'))
  }

  async sendSlackMessage(message, icon) {
    await sendSlackMessage(message, icon);
    this.props.showNotification(Translate.get('we_will_be_touch'),'success');
  }

  render() {
    return(
      <Onboarding
        onSendSlackMessage={::this.sendSlackMessage}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/projects/onboarding.js